'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useState, useEffect, useCallback, Suspense } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

function BuilderParamDetector({ onDetect }: { onDetect: (v: boolean) => void }) {
  const searchParams = useSearchParams();
  const has = searchParams.has('builder');
  useEffect(() => { onDetect(has); }, [has, onDetect]);
  return null;
}

function AppLayoutContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const [hasBuilderParam, setHasBuilderParam] = useState(false);
  const handleBuilderDetect = useCallback((v: boolean) => { setHasBuilderParam(v); }, []);

  const isBuilderPage = pathname?.startsWith('/builder') || hasBuilderParam;

  useEffect(() => {
    if (isBuilderPage) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
    return () => { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; };
  }, [isBuilderPage]);

  return (
    <div className={isBuilderPage ? 'h-screen overflow-hidden flex flex-col builder-page-wrapper' : ''}>
      <Header />
      <Suspense fallback={null}>
        <BuilderParamDetector onDetect={handleBuilderDetect} />
      </Suspense>
      <main className={isBuilderPage ? 'flex-1 flex flex-col overflow-hidden builder-desktop-no-padding' : ''}>
        {children}
      </main>
      {!isBuilderPage && <Footer />}
    </div>
  );
}

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return <AppLayoutContent>{children}</AppLayoutContent>;
}
